export const FETCH_DOCUMENTS_DATA = 'FETCH_DOCUMENTS_DATA';
export const FETCH_CRM_PROJECTS = 'FETCH_CRM_PROJECTS';
export const FETCH_PROJECTS_IN_LITE_VIEW = 'FETCH_PROJECTS_IN_LITE_VIEW';
export const FETCH_PROJECTS_BY_COMPANY = 'FETCH_PROJECTS_BY_COMPANY';
export const FETCH_TEMPLATES_DATA = 'FETCH_TEMPLATES_DATA';
export const FETCH_SUNBURST_DATA = 'FETCH_SUNBURST_DATA';
export const FETCH_DASHBOARD_DATA = 'FETCH_DASHBOARD_DATA';
export const FETCH_DASHBOARD_LITE = 'FETCH_DASHBOARD_LITE';
export const FETCH_TASK_VIEW = 'FETCH_TASK_VIEW';
export const FETCH_LEGAL_TASKS = 'FETCH_LEGAL_TASKS';
export const FETCH_INSIGHTS = 'FETCH_INSIGHTS';
export const PUT_INSIGHTS = 'PUT_INSIGHTS';
export const PASSWORD_RESET_MAIL = 'PASSWORD_RESET_MAIL';
export const REASSIGN_OWNER = 'REASSIGN_OWNER';
export const COPY_MAAP_LINK = 'COPY_MAAP_LINK';

export const PUT_MEDDPICC = 'PUT_MEDDPICC';

export const FETCH_GROUP_MAAP = 'FETCH_GROUP_MAAP';
export const GIVE_COMPANY_ACCESS = 'GIVE_COMPANY_ACCESS';
export const PUT_FORM_VALUES = 'PUT_FORM_VALUES';

export const COMPLETED_DATA = 'COMPLETED_DATA';
export const RELOAD_DATA = 'RELOAD_DATA';
export const QUARTER_DETAILS = 'QUARTER_DETAILS';
export const MONTHLY_DETAILS = 'MONTHLY_DETAILS';
export const SHOW_PROMPT = 'SHOW_PROMPT';
export const RESTART_PROMPT = 'RESTART_PROMPT';

export const FETCH_DEAL_POLICE = 'FETCH_DEAL_POLICE';
export const CREATE_DEAL_POLICE = 'CREATE_DEAL_POLICE';
export const UPDATE_DEAL_POLICE = 'UPDATE_DEAL_POLICE';

export const FETCH_CONTENTS = 'FETCH_CONTENTS';
export const ALL_CONTENTS = 'ALL_CONTENTS';
export const SINGLE_CONTENTS = 'SINGLE_CONTENTS';
export const POST_CONTENTS = 'POST_CONTENTS';
export const UPDATE_CONTENTS = 'UPDATE_CONTENTS';

export const POST_MAIL = 'POST_MAIL';

export const FETCH_TENANT_VALUES = 'FETCH_TENANT_VALUES';
export const FETCH_TENANT_ATTRIBUTES = 'FETCH_TENANT_ATTRIBUTES';
export const FETCH_SINGLE_TENANT_ATTRIBUTES = 'FETCH_SINGLE_TENANT_ATTRIBUTES';
export const CREATE_TENANT_ATTRIBUTES = 'CREATE_TENANT_ATTRIBUTES';
export const UPDATE_TENANT_ATTRIBUTES = 'UPDATE_TENANT_ATTRIBUTES';
export const BOARD_CUSTOM_ATTRIBUTES = 'BOARD_CUSTOM_ATTRIBUTES';

export const POST_CUSTOM_ATTRIBUTES = 'POST_CUSTOM_ATTRIBUTES';

export const FETCH_SINGLE_CARD = 'FETCH_SINGLE_CARD';
export const FETCH_ASSIGNEES = 'FETCH_ASSIGNEES';

export const SET_TAB_VALUE = 'SET_TAB_VALUE';

export const FETCH_EVENTS = 'FETCH_EVENTS';

export const CLONE_PROJECT = 'CLONE_PROJECT';
export const CLONE_DOCUMENT = 'CLONE_DOCUMENT';

export const SAVE_TASK_INFO = 'SAVE_TASK_INFO';
export const PUT_TASK_PREVIEW = 'PUT_TASK_PREVIEW';
export const UPDATE_TASK_INFO = 'UPDATE_TASK_INFO';
export const FETCH_FILTERED_TASKS = 'FETCH_FILTERED_TASKS';
export const POPULATE_FROM_TYPE = 'POPULATE_FROM_TYPE';
export const PROMPT_CONTEXT = 'PROMPT_CONTEXT';

export const CREATE_PROJECT = 'CREATE_PROJECT';

export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_SINGLE_USER = 'FETCH_SINGLE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_LITE_USER = 'UPDATE_LITE_USER';
export const CREATE_USER = 'CREATE_USER';
export const FETCH_FULL_USERS = 'FETCH_FULL_USERS';
export const FETCH_LIGHT_USERS = 'FETCH_LIGHT_USERS';
export const FETCH_USER_HIERARCHY = 'FETCH_USER_HIERARCHY';
export const FETCH_ORG_HIERARCHY = 'FETCH_ORG_HIERARCHY';

export const REQUEST_SECRET_URL = 'REQUEST_SECRET_URL';
export const POST_OTP = 'POST_OTP';
export const GET_TOKEN_2 = 'GET_TOKEN_2';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const LOGIN_WITH_OTP = 'LOGIN_WITH_OTP';
export const VENDOR_DETAILS = 'VENDOR_DETAILS';

export const STORE_DATA = 'STORE_DATA';

export const FETCH_COMMENTS = 'FETCH_COMMENTS';
export const FETCH_BOARD_COMMENTS = 'FETCH_BOARD_COMMENTS';
export const CREATE_COMMENTS = 'CREATE_COMMENTS';
export const CREATE_BOARD_COMMENTS = 'CREATE_BOARD_COMMENTS';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const UPDATE_BOARD_COMMENT = 'UPDATE_BOARD_COMMENT';

export const FETCH_SLACK_HISTORY = 'FETCH_SLACK_HISTORY';
export const FETCH_BOARD_MEMBERS = 'FETCH_BOARD_MEMBERS';
export const CREATE_SLACK_MESSAGE = 'CREATE_SLACK_MESSAGE';
export const CREATE_SLACK_CHANNEL = 'CREATE_SLACK_CHANNEL';
export const INVITE_SLACK_USERS = 'INVITE_SLACK_USERS';
export const INVITE_TO_SLACK_WORKSPACE = 'INVITE_TO_SLACK_WORKSPACE';

export const FETCH_COMPANIES = 'FETCH_COMPANIES';
export const CREATE_COMPANY = 'CREATE_COMPANY';
export const EDIT_COMPANY = 'EDIT_COMPANY';
export const COMPANY_FAV_ICON = 'COMPANY_FAV_ICON';
export const COMPANY_DETAILS = 'COMPANY_DETAILS';
export const FETCH_COMPANY_HIERARCHY = 'FETCH_COMPANY_HIERARCHY';

export const SHOW_LOADER = 'SHOW_LOADER';
export const TOGGLE_DIALOG = 'TOGGLE_DIALOG';
export const TOGGLE_COMPANIES = 'TOGGLE_COMPANIES';

export const SHOW_SNACKBAR_SUCCESS = 'SHOW_SNACKBAR_SUCCESS';
export const SHOW_SNACKBAR_WARNING = 'SHOW_SNACKBAR_WARNING';
export const SHOW_SNACKBAR_ERROR = 'SHOW_SNACKBAR_ERROR';
export const SHOW_SNACKBAR_INFO = 'SHOW_SNACKBAR_INFO';
export const SHOW_ALERT_BOX = 'SHOW_ALERT_BOX';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';

export const FETCH_DOCUMENTS_TYPE = 'FETCH_DOCUMENTS_TYPE';
export const FETCH_SINGLE_DOCUMENTS_TYPE = 'FETCH_SINGLE_DOCUMENTS_TYPE';
export const POST_DOCUMENTS_TYPE = 'POST_DOCUMENTS_TYPE';
export const UPDATE_DOCUMENTS_TYPE = 'UPDATE_DOCUMENTS_TYPE';

export const GET_DOCUMENTS_DATA = 'GET_DOCUMENTS_DATA';
export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const EDIT_DOCUMENT = 'EDIT_DOCUMENT';
export const SINGLE_CARD_DOCS = 'SINGLE_CARD_DOCS';
export const GET_DOCUMENT_CLAUSES = 'GET_DOCUMENT_CLAUSES';
export const GET_SINGLE_CLAUSE = 'GET_SINGLE_CLAUSE';
export const GET_CLAUSE_LIBRARY = 'GET_CLAUSE_LIBRARY';

export const FETCH_SINGLE_PROJECT = 'FETCH_SINGLE_PROJECT';
export const FETCH_SINGLE_PROJECT_HEADER = 'FETCH_SINGLE_PROJECT_HEADER';
export const REACTIVATE_LINK = 'REACTIVATE_LINK';
export const RESET_PASSWORD_MAIL = 'RESET_PASSWORD_MAIL';
export const RESET_PASSWORD = 'RESET_PASSWORD';

export const FETCH_CRM_DEALS = 'FETCH_CRM_DEALS';
export const FETCH_SINGLE_CRM = 'FETCH_SINGLE_CRM';
export const FETCH_CRM_COMPANY = 'FETCH_CRM_COMPANY';
export const FETCH_CRM_CONTACTS = 'FETCH_CRM_CONTACTS';
export const FETCH_CRM_CONNECTIONS = 'FETCH_CRM_CONNECTIONS';
export const FETCH_CRM_STATUS = 'FETCH_CRM_STATUS';
export const CRM_SYNC = 'CRM_SYNC';
export const CRM_DEALS_BY_SEARCH = 'CRM_DEALS_BY_SEARCH';

export const CREATE_TENANT = 'CREATE_TENANT';
export const CREATE_SUPER_USER = 'CREATE_SUPER_USER';
export const TEST_USER_EMAIL = 'TEST_USER_EMAIL';
export const UUID_DATA = 'UUID_DATA';
export const SUB_DOMAIN_PROP = 'SUB_DOMAIN_PROP';

export const NEW_PASSWORD_EMAIL = 'NEW_PASSWORD_EMAIL';
export const RESET_USER_MFA = 'RESET_USER_MFA';

export const POST_FEEDBACK = 'POST_FEEDBACK';
export const CURRENT_PATH = 'CURRENT_PATH';
export const SELECTED_USER = 'SELECTED_USER';

export const FETCH_STATUSES = 'FETCH_STATUSES';
export const FETCH_SINGLE_STATUS = 'FETCH_SINGLE_STATUS';
export const POST_PLAYBOOK_STATUS = 'POST_PLAYBOOK_STATUS';
export const PUT_PLAYBOOK_STATUS = 'PUT_PLAYBOOK_STATUS';
export const DELETE_PLAYBOOK_STATUS = 'DELETE_PLAYBOOK_STATUS';
export const FETCH_ANOTHER_STATUSES = 'FETCH_ANOTHER_STATUSES';

export const FETCH_ACCESS_GROUPS = 'FETCH_ACCESS_GROUPS';
export const POST_ACCESS_GROUPS = 'POST_ACCESS_GROUPS';
export const SINGLE_GROUP_ACCESS = 'SINGLE_GROUP_ACCESS';
export const FETCH_PERMISSIONS = 'FETCH_PERMISSIONS';
export const FETCH_ACCESS_PERMISSIONS = 'FETCH_ACCESS_PERMISSIONS';
export const FETCH_GROUP_PERMISSIONS = 'FETCH_GROUP_PERMISSIONS';
export const REMOVE_ACCESS_GROUP = 'REMOVE_ACCESS_GROUP';
export const REASSIGN_USER = 'REASSIGN_USER';

export const FETCH_FAQS = 'FETCH_FAQS';
export const SINGLE_FAQ = 'SINGLE_FAQ';

export const KEEP_TEXT = 'KEEP_TEXT';
export const SET_MESSAGE = 'SET_MESSAGE';
export const FETCH_FORECAST = 'FETCH_FORECAST';

export const FETCH_TASK_STEPS = 'FETCH_TASK_STEPS';
export const SINGLE_TASK_STEPS = 'SINGLE_TASK_STEPS';
export const CREATE_TASK_STEPS = 'CREATE_TASK_STEPS';
export const EDIT_TASK_STEPS = 'EDIT_TASK_STEPS';
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS';
export const MAAP_ACCESS = 'MAAP_ACCESS';
export const FETCH_TAGS = 'FETCH_TAGS';
export const MAAP_LINK = 'MAAP_LINK';

/* For Admin page */
export const FETCH_ALL_TENANTS = 'FETCH_ALL_TENANTS';
export const SAVE_TENANT = 'SAVE_TENANT';
